import styled from "styled-components";

export const StyledMain = styled.main`
    max-width: 900px;
    margin: 0 auto;
    @media(max-width: 939px) {
        margin: 0px 20px;
    }
`;